import { defineMessages } from 'react-intl';

export default defineMessages({
  optionNamePlaceholder: {
    id: 'sku.modifiers.option-row.name-placeholder',
    defaultMessage: 'Option name',
  },
  optionNameAriaLabel: {
    id: 'sku.modifiers.option-row.name-aria-label',
    defaultMessage: 'Option name',
  },
  nameRequired: {
    id: 'sku.modifiers.option-row.name-required',
    defaultMessage: 'Enter an option name',
  },
  nameNotUnique: {
    id: 'sku.modifiers.option-row.name-not-unique',
    defaultMessage: 'Option names must be unique within this modifier',
  },
  optionActionsAriaLabel: {
    id: 'sku.modifiers.option-row.actions-aria-label',
    defaultMessage: 'Options for {name}',
  },
  optionDragHandleAriaLabel: {
    id: 'sku.modifiers.option-row.drag-handle-aria-label',
    defaultMessage: 'Reorder {name}',
  },
  deleteOption: {
    id: 'sku.modifiers.option-row.delete',
    defaultMessage: 'Delete option',
  },
});
